import _ from 'lodash';
import timm from 'timm';

import { Types as CadminMatchInqsTypes } from 'app/actions/company-admin/match-inquiries';
import utils from 'app/reducers/utils';

const initialState = {};

const reducer = utils.createReducer(initialState, {

  [`${CadminMatchInqsTypes.SEARCH}_RESOLVED`]: (state, {result: {matchInquiries}}) => {
    return timm.mergeDeep(state, utils.idMap(matchInquiries));
  },

});

export default reducer;
